export default function ({state, getters, commit, dispatch}, vm) {
    vm.$confirm('Удалить платеж по сертификату?', 'Удаление платежа №', {
        confirmButtonText: 'Удалить',
        cancelButtonText: 'Отмена',
        type: 'info'
    }).then(() => {
        commit('loading', true);
        axios({
            method: 'post',
            url: '/tourclient/payment/deletePayment?id=' + state.Id,
            data: 'id=' + state.Id,
            requestId: '/tourclient/payment/deletePayment'
        }).then(({data}) => {
            commit('loading');
            if (HasError(data, {text: 'Ошибка при удалении платежа'})) {
                return;
            }
            window.app.$notify.success({
                message: 'Платёж удален',
            });
            dispatch('subsidies/item/create', {type: 'edit', id: getters.data.CertificateId}, {root: true});
            commit('loading');
        }).catch(e => {
            commit('loading');
        });
    }).catch(e => {
    });
}
